import Point from "./point";

export class PlotData {
  id: string;
  plotPoint: Point;
}
